const api = {
    searchData: '/api/v1/search/data',
    genomeList: '/api/v1/genome/list',
    genomeInfo: "/api/v1/genome/info",
    genomeFamily: "/api/v1/genome/family",
    familyDown: "/api/v1/family/download",
    geneInfo: "/api/v1/gene/info",
    transcriptInfo: "/api/v1/transcript/info",
    pathway_tree: "/api/v1/genome/pathway/tree",
    batchDown: "/api/v1/batch/down",
    pathwayExample: "/api/v1/pathway/example",
    pathwayDownfile: "/api/v1/pathway/downfile",
    goDownfile: "/api/v1/go/downfile",
    goAnalysis: "/api/v1/go/analysis",
    goExample: "/api/v1/go/example",
    ssearch: "/api/v1/search/ssearch",
    goResult: "/api/v1/go/result",
    downgo: "/api/v1/go/downgo",
    pathwayAnalysis: "/api/v1/pathway/analysis",
    pathwayDownfile: "/api/v1/pathway/downfile",
    pathwayResult: "/api/v1/pathway/result",
    downpway: "/api/v1/pathway/downpway",
    syntenyGenomeinfos: "/api/v1/synteny/genomeinfos",
    syntenyAnalysis: "/api/v1/synteny/analysis",
    syntenyResult: "/api/v1/synteny/result",
    syntenyBlock: "/api/v1/synteny/block"
}

export default api